var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "soical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    transform: "translate(-573.000000, -738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square-black",
    transform: "translate(173.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "square-65",
    className: "st1",
    d: "M494.94,650h810.12c24.82,0,44.94,20.06,44.94,44.94v810.12c0,24.82-20.06,44.94-44.94,44.94 H494.94c-24.82,0-44.94-20.06-44.94-44.94V694.94C450,670.12,470.06,650,494.94,650z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(182.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location",
    className: "st2",
    d: "M715.62,1033.77c0,95.6,173.08,319.18,173.08,313.11s173.08-217.51,173.08-313.11 c0-95.6-77.54-173.08-173.08-173.08S715.62,938.17,715.62,1033.77z M802.15,1016.46c0,47.8,38.77,86.54,86.54,86.54 c47.77,0,86.54-38.74,86.54-86.54c0-47.8-38.77-86.54-86.54-86.54C840.92,929.92,802.15,968.66,802.15,1016.46z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.71766f61d59ab9586470d159959eee72.svg";
export { ForwardRef as ReactComponent };